module.exports = __webpack_public_path__ + "img/remove_circle_outline_material.7e932276.svg";